// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b16d92b7","977":"e74e02bd"}[chunkId] + ".chunk.js";
};